import { render, staticRenderFns } from "./ExercismAnnotatedCard.vue?vue&type=template&id=e50abd04&scoped=true&"
import script from "./ExercismAnnotatedCard.vue?vue&type=script&lang=js&"
export * from "./ExercismAnnotatedCard.vue?vue&type=script&lang=js&"
import style0 from "./ExercismAnnotatedCard.vue?vue&type=style&index=0&id=e50abd04&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50abd04",
  null
  
)

export default component.exports